/**
 * @module WindowUtils
 */

/** @memberOf module:WindowUtils
 *
 * Megvizsgálja, hogy az oldal alján vagyunk-e
 * @returns {boolean}
 */
export function isPageBottomVisible() {
    return document.documentElement.clientHeight + window.scrollY >= (document.documentElement.scrollHeight
        || document.documentElement.clientHeight);
}

/** @memberOf module:WindowUtils
 *
 * Megvizsgálja hogy az oldal tetején vagyunke-
 * @returns {boolean}
 */
export function isPageTopVisible() {
    return document.documentElement.scrollTop === 0;
}

/**
 * Visszaadja a használt eszköz típusát (Mobile vagy Desktop)
 * @returns {string}
 */
export function getDeviceType() {
    const regex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent) ? 'Mobile' : 'Desktop';
}

/**
 * Viszaadja hogy a haszánlt eszköz mobiltelefon-e
 * @returns {boolean}
 */
export function isMobile() {
    return getDeviceType() === 'Mobile';
}

/**
 * Visszaadja hogy a haszánlt eszköz asztali gép-e
 * @returns {boolean}
 */
export function isDesktop() {
    return getDeviceType() === 'Desktop';
}

/**
 * Visszaadja egy adott nevű cookie értékét
 * @param {string} name A cookie neve
 * @returns {string}
 */
export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return undefined;
}

/**
 * Átíriánytja az oldalt egy POST hívással együtt (form submit)
 * @param {string} url Az új oldal elérési útja
 * @param {object} params POST paraméterek
 */
export function redirectWithPost(url, params) {
    const form = document.createElement('form');
    form.action = url;
    form.method = 'POST';
    form.style.display = 'none';
    Object.keys(params).forEach((key) => {
        const input = document.createElement('input');
        input.name = key;
        input.value = params[key];
        form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
}

/**
 * Megynyit egy tartalmat egy új oldalon megadott paraméterekkel, ha stringet vagy html-t akarunk megjeleníteni
 * akkor a content paraméterben kell átatni a függvények és a write paramétert true-ra, az url pedig null-ra
 *
 * Ha az adat urlben van pl.: base64 pdf megjelenítése új ablakban, akkor a write paramétert false-ra kell állítani
 *
 * @param {string } content az új oldal tartalma, akkor jelenik meg ha a write paraméter true
 * @param {string} url csak ha nincs content egyébként a shared about:blank
 * @param {number} width Az új oldal szélessége
 * @param {number} height Az új oldal magassága
 * @param {boolean} write Annak eldöntése hogy a contentet írjuk az oldalra vagy az url-be van az új oldal tartalma
 */
export function openInNewTab(content, url = 'about:blank', width = 800, height = 600, write) {
    const dimensions = `width=${width} height=${height}`;
    const win = window.open(url, '', dimensions);
    if (write) {
        win.document.write(
            `<div style="width:${width};height:${height};">`
            + '<textarea spellcheck="false" rows="100" cols="100" style="border:none; '
            + ` box-sizing: border-box; width=100%; height=100%;">${content}</textarea></div>`,
        );
    }
}

export function openDijkalkInfo({
    calltype, url, tarifaId, id, biztositoid, request, response, remark,
}) {
    const dimensions = `width=${800} height=${800}`;
    const win = window.open('about:blank', '', dimensions);
    let html = `<h3> Tarifa Id: ${tarifaId}  Id: ${id}  Calltype: ${calltype}  Biztosito: ${biztositoid}</h3>`;
    html += `<h3> URL: ${url} <h3>`;

    html += '<h4> Request:  </h4>';
    html += `<div><textarea style="width:600px; height: 250px;">${request}</textarea> </div>`;

    html += '<h4> Response:  </h4>';
    html += `<div><textarea style="width:600px; height: 250px;">${response}</textarea> </div>`;

    html += '<h4> Remark:  </h4>';
    html += `<div>${remark} </div>`;

    win.document.write(`<div style="width:${800}px;height:${800}px;">${html}</div>`);
}

/**
 * Base64 adatot alakít blob típusú objektummá
 * @param {string} clonedB64Data base64 adat amit blob objektummá akarunk alakítani
 * @param {string} contentType az adat típusa  pl.: application/pdf
 * @returns {Blob}
 */
export function b64toBlob(b64Data, contentType = '') {
    const sliceSize = 512;
    let clonedB64Data = b64Data;
    clonedB64Data = clonedB64Data.replace(/^[^,]+,/, '');
    clonedB64Data = clonedB64Data.replace(/\s/g, '');
    const byteCharacters = window.atob(clonedB64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i += 1) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
}

/**
 *
 * @returns {number}
 */
export function getClientHeight() {
    return Math.max(document.documentElement.clientHeight, window.innerHeight);
}
